<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.level_required'),
                        href: null,
                    },
                    {
                        name: subject.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <PageSectionCollapsible class="mt-5" is-open>
            <template v-slot:title>
                <h2>{{ $tc('messages.content_blocks', 2) }}</h2>
            </template>

            <div class="mt-5">
                <div class="bg-gray-100 overflow-hidden rounded-lg mt-3">
                    <div class="px-4 py-5 sm:p-6">
                        <div class="flex flex-col mt-5">
                            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                                <div
                                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                                >
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead>
                                            <tr class="text-white">
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"
                                                >
                                                    {{ $tc('messages.tags', 2) }}
                                                </th>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"
                                                    v-for="gradeLevel in gradeLevels"
                                                    :key="gradeLevel.id"
                                                >
                                                    {{ gradeLevel.name }}
                                                </th>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"
                                                ></th>
                                            </tr>
                                        </thead>
                                        <template v-for="block in blocks" :key="block.id">
                                            <thead>
                                                <tr>
                                                    <th
                                                        class="max-w-xs px-6 py-3 bg-gray-300 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                                                        :colspan="3 + gradeLevels.length"
                                                    >
                                                        {{ block.name }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="section in block.sections" :key="section.name">
                                                <tr>
                                                    <td
                                                        :colspan="3 + gradeLevels.length"
                                                        class="max-w-xs px-6 py-3 bg-gray-200 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                                                    >
                                                        {{ section.name }}
                                                    </td>
                                                </tr>
                                                <tr v-for="tag in section.tags" :key="tag.id" class="group">
                                                    <td
                                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex gap-2"
                                                    >
                                                        <span>{{ tag.name }}</span>

                                                        <span
                                                            :title="$tc('messages.links', 2)"
                                                            v-if="tag.form_links.length"
                                                        >
                                                            <IconExternalLink class="h-4 w-4 text-indigo-400" />
                                                        </span>

                                                        <span
                                                            :title="$tc('messages.prerequisites', 2)"
                                                            v-if="tag.tag_ids.length"
                                                        >
                                                            <IconTag class="h-4 w-4 text-indigo-400" />
                                                        </span>
                                                    </td>
                                                    <td
                                                        class="px-6 py-4 whitespace-nowrap leading-5 text-center"
                                                        v-for="expectedLevel in tag.expectedLevels"
                                                        :key="expectedLevel.grade_level_id"
                                                        :class="{
                                                            'bg-red-400 text-red-800': expectedLevel.level === 1,
                                                            'bg-orange-400 text-orange-800': expectedLevel.level === 2,
                                                            'bg-yellow-400 text-yellow-800': expectedLevel.level === 3,
                                                            'bg-blue-400 text-blue-800': expectedLevel.level === 4,
                                                            'bg-green-400 text-green-800': expectedLevel.level === 5,
                                                        }"
                                                    >
                                                        <span class="invisible group-hover:visible">{{
                                                            expectedLevel.level
                                                        }}</span>
                                                    </td>
                                                    <td
                                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500"
                                                    >
                                                        <div class="flex justify-end space-x-2">
                                                            <InertiaSquareLinkButton
                                                                element="button"
                                                                action="edit"
                                                                href="/"
                                                                @click="selectedTag = tag"
                                                                v-if="meta.can.edit"
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="selectedTag">
                <EditTagPanel :tag="selectedTag" :tags="allTags" @close="selectedTag = null" />
            </template>
        </PageSectionCollapsible>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import PageSectionCollapsible from '../../../../Shared/PageSectionCollapsible.vue';
import InertiaSquareLinkButton from '../../../../components/InertiaSquareLinkButton.vue';
import EditTagPanel from '../../../Admin/Categories/partials/EditTagPanel.vue';
import { IconChartArrowsVertical, IconExternalLink, IconTag } from '@tabler/icons-vue';

export default {
    components: {
        IconTag,
        IconExternalLink,
        IconChartArrowsVertical,
        EditTagPanel,
        InertiaSquareLinkButton,
        PageSectionCollapsible,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'subject', 'gradeLevels', 'blocks', 'allTags'],
    data() {
        return {
            selectedTag: null,
        };
    },
    methods: {},
};
</script>
